import Vue from 'vue'
import Vuex from 'vuex'
import {LoginAPI} from "../apis/LoginAPI";
import accountStore from '../modules/account/store'
import calculatorStore from '../modules/calculator/store'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user: {
            info: {},
            isLoggedIn: false
        },
        appData: {
            isUploadInProgress: false
        }
    },
    mutations: {
        setUserData(state, info) {
            state.user.info = info;
            state.user.isLoggedIn = true;
        },
        setUploadStatus(state, status) {
            state.appData.isUploadInProgress = status;
        },
    },
    actions: {
        async loginUser(context, {email, password}) {
            let resp = await LoginAPI.login(email, password)
            if (resp.httpStatus === 200) {
                context.commit('setUserData', resp)
                return resp;
            }
            return false;
        },
        async updateUserData(context) {
            try {
                let resp = await LoginAPI.getUserInfo();
                if (resp.logged_in) {
                    context.commit('setUserData', resp);
                    return true;
                }
            }
            catch (e) {
                console.warn(e)
            }

            return false;
        }
    },
    getters: {
        isLoggedIn: (state) => {
            return state.user.isLoggedIn
        },
        userInfo: (state) => {
            return state.user.info.user
        },
        hasProfile: (state) => {
            return state.user.info.has_profile
        },
        isStartup(state) {
            return state.user.info.user && state.user.info.user.user_type === "Startup"
        },
        isInvestor(state) {
            return state.user.info.user && state.user.info.user.user_type === "Investor"
        }
    },
    modules: {
        account: accountStore,
        calculator: calculatorStore,
    }
})
